import React, { FC } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import {
    ActionButton,
    ToastStatus,
} from '../../constants/toastMessage.constants';

export interface ToastMessageProps {
    status: ToastStatus;
    title: string;
    description?: string;
    actionButton?: ActionButton;
}
const ToastMessage: FC<ToastMessageProps> = ({
    status,
    title,
    description,
    actionButton,
}) => {
    return (
        <Container>
            <Title status={status}>{title}</Title>
            {description && <Description>{description}</Description>}
            {actionButton &&
                ('href' in actionButton ? (
                    <Link
                        href={actionButton.href}
                        target={actionButton.target ?? '_self'}
                        rel={
                            actionButton.target === '_blank'
                                ? 'noopener noreferrer'
                                : undefined
                        }
                    >
                        {actionButton.name}
                    </Link>
                ) : (
                    <Button onClick={actionButton.action}>
                        {actionButton.name}
                    </Button>
                ))}
        </Container>
    );
};
const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(2),
});
const Title = styled.h1<{ status: ToastStatus }>(({ status }) => ({
    display: 'flex',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.heavy,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.toastTitleColor[status],
}));
const Description = styled.p({
    display: 'flex',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.textAccessibleWG01,
});
const Button = styled.div({
    display: 'flex',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.heavy,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.solidA02,
    cursor: 'pointer',
});

const Link = styled.a(() => ({
    textDecoration: 'none',
    color: aampeTheme.colors.solidA02,
    fontWeight: aampeTheme.weights.heavy,
    fontSize: aampeTheme.size.font.textMedium,
}));

export default ToastMessage;
